import { render, staticRenderFns } from "./treeMenu.vue?vue&type=template&id=6d8b8d6f&scoped=true&"
import script from "./treeMenu.vue?vue&type=script&lang=js&"
export * from "./treeMenu.vue?vue&type=script&lang=js&"
import style0 from "./treeMenu.vue?vue&type=style&index=0&id=6d8b8d6f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8b8d6f",
  null
  
)

export default component.exports